import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SvgIconComponent, injectRegisterIcons } from '@ngneat/svg-icon';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';

import { dismissConnectionLostOverlay } from '@core/stores/websocket/websocket.actions';
import { selectConnectionLostOverlayVisible } from '@core/stores/websocket/websocket.selectors';

import { ButtonComponent } from '@shared/components/button';

import { appClose16Icon } from '@icons/close-16';
import { appFaulted16Icon } from '@icons/faulted-16';

@Component({
  selector: 'app-connection-lost-overlay',
  imports: [SvgIconComponent, TranslatePipe, ButtonComponent],
  templateUrl: './connection-lost-overlay.component.html',
  styleUrl: './connection-lost-overlay.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col' },
})
export class ConnectionLostOverlayComponent {
  readonly #store = inject(Store);

  public readonly visible = this.#store.selectSignal(selectConnectionLostOverlayVisible);

  constructor() {
    injectRegisterIcons([appFaulted16Icon, appClose16Icon]);
  }

  public onRefreshClick(): void {
    window.location.reload();
  }

  public onCloseClick(): void {
    this.#store.dispatch(dismissConnectionLostOverlay());
  }
}
